import React, { useState } from 'react';

import RecreateFilters from '../../../../id8/components/recreate/filters/RecreateFilters';
import RecreateOutput from '../../../../id8/components/recreate/output/RecreateOutput';
import UploadModal from '../../../../id8/components/recreate/upload-modal/UploadModal';
import { PROMPT_TYPE } from '../../../../constants';
import ImagesGeneratingConsumerStatusController from '../generating-status-controller/ImagesGeneratingConsumerStatusController';
import { useProject } from '../../../../context/ProjectContext';

import scss from '../../Id8.module.scss';

function RecreateTab() {
  const [isShowUploadModal, setIsShowUploadModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  const { actions } = useProject();

  const handleShowUploadModal = (files) => {
    const image = files[0];
    setUploadedImage(image);
    setIsShowUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setIsShowUploadModal(false);
    setUploadedImage(null);
  };

  const handleRecreate = (values) => {
    actions('recreateAd', values);
  };

  return (
    <div className={scss.outputWrapper}>
      <RecreateFilters onShowUploadModal={handleShowUploadModal} />

      <RecreateOutput onShowUploadModal={handleShowUploadModal} />

      <UploadModal
        isOpen={isShowUploadModal}
        onClose={handleCloseUploadModal}
        uploadedImage={uploadedImage}
        onChangeImage={setUploadedImage}
        onSubmit={handleRecreate}
      />

      <ImagesGeneratingConsumerStatusController
        promptType={PROMPT_TYPE.RECREATE}
        generationLabel='recreateImagesInProgress'
      />
    </div>
  );
}

export default RecreateTab;
